export const myModalStyles = {
  dialog: {
    '& .MuiDialog-container': {
      '& .MuiDialog-paper': {
        margin: 2,
      },
    },
  },

  paper: (theme, isMobile) => ({
    borderRadius: isMobile ? 0 : '16px',
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.20)'
        : '0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.20)',
    maxHeight: isMobile ? '100vh' : '90vh',
    minHeight: isMobile ? '100vh' : 'auto',
  }),

  title: {
    p: 0,
    pb: 1,
    borderBottom: '1px solid',
    borderColor: 'divider',
  },

  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: 2,
  },

  titleText: {
    fontWeight: 600,
    color: 'text.primary',
  },

  closeButton: {
    color: 'text.secondary',
    '&:hover': {
      bgcolor: 'action.hover',
    },
  },

  content: {
    p: 3,
    '&:first-of-type': {
      pt: 3,
    },
  },

  actions: {
    p: 3,
    pt: 2,
    borderTop: '1px solid',
    borderColor: 'divider',
    gap: 2,
    justifyContent: 'flex-end',
  },
};
